module.exports = __webpack_public_path__ + "static/img/banner-cursos-home-768x1024.9ab2c87.jpg";


//////////////////
// WEBPACK FOOTER
// ./src/assets/images/banners/banner-cursos-home-768x1024.jpg
// module id = +fD4
// module chunks = 47